export function parseStatus(status) {
  if (status == "FINALIZED") {
    return "finished";
  }

  if (status == "SELECTED_PLAYERS") {
    return "roaster-ready";
  }

  if (status == "NOT_STARTED") {
    return "upcoming";
  }

  return "playing";
}
